(function () {
  'use strict';

  var configNode = document.getElementById('boi-wiser-config');
  if (!configNode) return;

  var config;
  try {
    config = JSON.parse(configNode.textContent || '{}');
  } catch (error) {
    return;
  }

  var loadPromise;
  var widgetSelector = '[data-wiser-widget]:not([data-wiser-page="cartdrawer"]), .ws_inr_main_wgt, .ws_crt_wgt:not([data-wiser-page="cartdrawer"]), .evm-also-bought-products, .evm-related-vendor-product, .evm-related-product:not([data-wiser-page="cartdrawer"]), .evm-related-viewed-browsing, .recently-viewed, .trending-products, .evm-most-popular-products';

  function loadWiser() {
    if (loadPromise) return loadPromise;
    loadPromise = new Promise(function (resolve, reject) {
      if (window.__boiWiserLoaded) {
        resolve();
        return;
      }

      if (!document.querySelector('link[data-boi-wiser-style]')) {
        var stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.href = config.styleUrl;
        stylesheet.dataset.boiWiserStyle = 'true';
        document.head.appendChild(stylesheet);
      }

      var script = document.createElement('script');
      script.src = config.scriptUrl;
      script.async = true;
      script.dataset.boiWiserRuntime = 'true';
      script.onload = function () {
        window.__boiWiserLoaded = true;
        document.dispatchEvent(new CustomEvent('boi:wiser-loaded'));
        resolve();
      };
      script.onerror = function () {
        loadPromise = null;
        reject(new Error('Unable to load Wiser runtime'));
      };
      document.head.appendChild(script);
    });
    return loadPromise;
  }

  window.BoiLoadWiser = loadWiser;

  function containsRenderedContent(widget) {
    if (widget.hasAttribute('data-widget-rendered')) return true;
    for (var index = 0; index < widget.children.length; index += 1) {
      if (!widget.children[index].classList.contains('boi-wiser-placeholder')) return true;
    }
    return false;
  }

  function settlePlaceholder(widget) {
    if (!containsRenderedContent(widget)) return false;
    var placeholder = widget.querySelector('.boi-wiser-placeholder');
    if (placeholder) placeholder.remove();
    widget.removeAttribute('aria-busy');
    widget.setAttribute('data-boi-wiser-state', 'ready');
    return true;
  }

  function prepareHomeWidgets() {
    var scope = document.querySelector('main.main-content') || document;
    scope.querySelectorAll(widgetSelector).forEach(function (widget) {
      widget.setAttribute('aria-busy', 'true');
      widget.setAttribute('data-boi-wiser-state', 'loading');
      if (!widget.querySelector('.boi-wiser-placeholder')) {
        var placeholder = document.createElement('div');
        placeholder.className = 'boi-wiser-placeholder';
        placeholder.setAttribute('role', 'status');
        placeholder.innerHTML = '<span class="boi-wiser-placeholder__label">' + config.loadingLabel + '</span><span class="boi-wiser-placeholder__cards" aria-hidden="true"><span></span><span></span><span></span></span>';
        widget.appendChild(placeholder);
      }
    });
  }

  function armNearViewportLoading() {
    var armed = false;
    var observer;

    function widgets() {
      return Array.prototype.slice.call(document.querySelectorAll(widgetSelector));
    }

    function loadIfNear() {
      if (!armed) return;
      var nodes = widgets();
      for (var index = 0; index < nodes.length; index += 1) {
        var rect = nodes[index].getBoundingClientRect();
        if (rect.top <= window.innerHeight + (config.home ? 200 : 300) && rect.bottom >= -300) {
          if (observer) observer.disconnect();
          window.removeEventListener('scroll', loadIfNear);
          loadWiser().catch(function () {});
          return;
        }
      }
    }

    function arm(event) {
      if (armed || event && event.isTrusted === false) return;
      if (event && event.type === 'keydown' && ['ArrowDown', 'PageDown', 'End', ' '].indexOf(event.key) === -1) return;
      armed = true;
      window.removeEventListener('wheel', arm);
      window.removeEventListener('touchmove', arm);
      window.removeEventListener('pointerdown', arm);
      window.removeEventListener('keydown', arm);

      var nodes = widgets();
      if ('IntersectionObserver' in window && nodes.length) {
        observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            observer.disconnect();
            loadWiser().catch(function () {});
          }
        }, { rootMargin: '0px 0px ' + (config.home ? 200 : 300) + 'px 0px', threshold: 0.01 });
        nodes.forEach(function (widget) { observer.observe(widget); });
      } else {
        window.addEventListener('scroll', loadIfNear, { passive: true });
      }
      loadIfNear();
    }

    window.addEventListener('wheel', arm, { once: true, passive: true });
    window.addEventListener('touchmove', arm, { once: true, passive: true });
    window.addEventListener('pointerdown', arm, { once: true, passive: true });
    window.addEventListener('keydown', arm);
    window.addEventListener('scroll', function () {
      arm();
      loadIfNear();
    }, { once: true, passive: true });
  }

  function normalizeBadges(root) {
    root.querySelectorAll('.ws_product_Bage_wrapper').forEach(function (wrapper) {
      if (wrapper.dataset.boiBadgesNormalized === 'true') return;
      var badges = wrapper.querySelectorAll('.ws_badge');
      if (badges[0]) {
        var volume = parseFloat(badges[0].textContent);
        if (!isNaN(volume)) badges[0].textContent = volume + (volume === 375 ? ' ml' : ' cl');
      }
      if (badges[1]) {
        var percentage = parseFloat(badges[1].textContent);
        if (!isNaN(percentage)) badges[1].textContent = percentage + '%';
      }
      wrapper.dataset.boiBadgesNormalized = 'true';
    });
  }

  function observeLoadedWidgets() {
    var widgets = document.querySelectorAll(widgetSelector);
    widgets.forEach(function (widget) {
      var settleTimer;
      var observer = new MutationObserver(function () {
        normalizeBadges(widget);
        settlePlaceholder(widget);
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(function () { observer.disconnect(); }, 1200);
      });
      normalizeBadges(widget);
      settlePlaceholder(widget);
      observer.observe(widget, { childList: true, subtree: true, characterData: true });
      settleTimer = window.setTimeout(function () { observer.disconnect(); }, 5000);
    });
  }

  document.addEventListener('boi:wiser-loaded', observeLoadedWidgets);
  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest('[data-cart-toggle], .cart-icon, .header_cart, .baskettop')) {
      loadWiser().catch(function () {});
    }
  }, { passive: true });
  document.addEventListener('cart:updated', function () { loadWiser().catch(function () {}); });

  if (config.immediate) {
    loadWiser().catch(function () {});
  } else if (config.lazy) {
    if (config.home) prepareHomeWidgets();
    armNearViewportLoading();
  }
})();
